import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { WidgetMobile } from "./WidgetMobile";

if (!document.querySelector('link[href="/fonts.css"]')) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "/fonts.css";
  document.head.appendChild(link);
}

// Dev-only: show a visible frame
if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  Object.assign(document.body.style, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    background: "#222",
  });
  const frame = document.createElement("div");
  frame.style.cssText = "outline: 2px dashed red; width: 100%; flex-shrink: 0;";
  const root = document.getElementById("root")!;
  frame.appendChild(root);
  document.body.appendChild(frame);
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <WidgetMobile />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
